import React from "react";
import { Div, Text } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

class InfluencersHow extends React.Component {
  render() {
    const { images, howItWorks } = this.props;
    return (
      <>
        <WebsiteContainer>
          <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
            <Div className="influencer-how">
              <Div m={{ x: { xs: "1.5rem", md: "0" } }}>
                <Div m={{ b: "4rem" }} d="flex" align="center">
                  <Div
                    bg="black700"
                    w={{ lg: "5.125rem", xs: "3.625rem" }}
                    h={{ lg: "5.125rem", xs: "3.625rem" }}
                  ></Div>
                  <Text
                    transform={{
                      lg: "translateX(-3.125rem)",
                      xs: "translateX(-2rem)",
                    }}
                    textSize={{ lg: "display4", xs: "caption4" }}
                    textWeight="bold"
                    tag="h2"
                  >
                    How it works
                  </Text>
                </Div>
                <Div
                  d="flex"
                  justify="space-between"
                  flexDir={{ lg: "row", md: "row", xs: "column" }}
                >
                  {howItWorks.map((howItWork, index) => {
                    return (
                      <Div
                        key={index}
                        m={{
                          b: { lg: "0", md: "0", xs: "2rem" },
                          r: { md: "1rem" },
                        }}
                      >
                        <Text
                          m={{ b: "1rem" }}
                          textColor="gray700"
                          fontFamily="secondary"
                          textWeight="bold"
                        >
                          {`0${index + 1}`}
                        </Text>
                        <Text
                          className="how-points-heading"
                          w="14rem"
                          m={{ b: "1rem" }}
                          textSize="title2"
                          textWeight="700"
                          tag="h3"
                        >
                          {howItWork.title}
                        </Text>
                        <Text
                          maxW={{ lg: "16.44rem" }}
                          textColor="gray700"
                          textWeight="500"
                        >
                          {howItWork.description.description}
                        </Text>
                      </Div>
                    );
                  })}
                </Div>
              </Div>
            </Div>
          </CustomContainer>
        </WebsiteContainer>
        <Div m={{ t: "6rem" }}>
          <ImageLink
            link={images[0].description}
          >
            <Div
              bgImg={images[0].file.url}
              bgSize="cover"
              bgRepeat="no-repeat"
              bgPos="center"
              p={{ b: {xs: "64.6%", md: "32.3%"} }}
            ></Div>
          </ImageLink>
          <Div d={{ md: "flex" }}>
            <Div flexGrow="1">
              <ImageLink
                link={images[1].description}
              >
                <Div
                  bgImg={images[1].file.url}
                  bgSize="cover"
                  bgPos="center"
                  p={{ b: "64.6%" }}
                ></Div>
              </ImageLink>
            </Div>

            <Div flexGrow="1">
              <ImageLink
                link={images[2].description}
              >
                <Div
                  bgImg={images[2].file.url}
                  bgSize="cover"
                  bgPos="center"
                  p={{ b: "64.6%" }}
                ></Div>
              </ImageLink>
            </Div>
          </Div>
        </Div>
      </>
    );
  }
}

export default InfluencersHow;
